import { gray, white } from '~/common/styles/colors'
import { TabVariant } from '~/components/ui/atoms/tabs/types'

export function getTabColorPrimitives(variant: TabVariant, isSelected: boolean) {
  const key = `${variant}-${isSelected}`
  switch (key) {
    case 'primary-false': {
      return {
        default: {
          color: gray[9],
          fill: white,
          stroke: gray[4],
          strokeWidth: 1,
        },
        hover: {
          color: gray[10],
          fill: white,
          stroke: gray[6],
        },
      }
    }
    case 'primary-true': {
      return {
        default: {
          color: gray[10],
          fill: gray[2],
          stroke: gray[4],
          strokeWidth: 1,
        },
        hover: {
          color: gray[10],
          fill: gray[2],
          stroke: gray[6],
        },
      }
    }
    case 'ghost-false': {
      return {
        default: {
          color: gray[9],
          fill: 'none',
        },
        hover: {
          fill: 'none',
          color: gray[10],
        },
      }
    }
    case 'ghost-true': {
      return {
        default: {
          fill: 'none',
          color: gray[10],
        },
        hover: {
          fill: 'none',
          color: gray[10],
        },
      }
    }
    default: {
      throw new Error(`Unhandled key: ${key}`)
    }
  }
}

export function getTabWithSelectionShape(selected: boolean) {
  if (selected) {
    return (
      <div style={{ position: 'relative' }}>
        <svg
          className="svgTabOutline"
          height="50"
          preserveAspectRatio="none"
          viewBox="15 0 156 40"
          width="220"
        >
          <path
            className="svgTabOutlinePath"
            d="
        M 18 36.5
        H 170
        L 164 10
        C 163 7, 161 5, 158 5
        H 31
        C 27 5, 26 7, 25 10
        L 18 36.75
        "
          />
        </svg>
        <svg
          className="svgTabOutlineBorder"
          height="50"
          preserveAspectRatio="none"
          style={{ position: 'absolute', top: 0, left: 0 }}
          viewBox="15 0 156 40"
          width="150"
        >
          <path
            className="svgTabOutlineBorderPath"
            d="
          M 19.6 37
          H 168.5
        "
            strokeLinecap="round"
          />
        </svg>
      </div>
    )
  } else {
    return (
      <svg
        className="svgTabOutline"
        height="50"
        preserveAspectRatio="none"
        viewBox="15 0 156 40"
        width="150"
      >
        <path
          className="svgTabOutlinePath"
          d="
    M 18 36.5
    H 170
    L 164 10
    C 163 7, 161 5, 158 5
    H 31
    C 27 5, 26 7, 25 10
    L 18 36.75
    "
        />
      </svg>
    )
  }
}
